

import './support/legacy/ie.js';
import './vendor.js';

import './util/cf7.js';
import './util/character-limit.js';

import './listen/history.js';
import './listen/toggle.js';
import './listen/image/orientation.js';
import './listen/match-height.js';

import './listen/externalize-links.js';
import './listen/galleryify.js';

import './listen/form/reset.js';

import './widget/player--video.js';

import { Gallery } from './widget/gallery.js';
import './widget/slick-slider.js';
import './widget/quote.js'; // TODO: only use slick-slider.js

import './widget/wine.js';

// gallery on load handle for pages
(
    new Gallery()
);


// WEBPACK FOOTER //
// ./tbo/js/app.js